import React, { useState, useEffect } from "react";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min.js";
import jwt_decode from "jwt-decode";
import axios from "axios";
import apiConfig from '../apiConfig';


const ProfileManage = () => {
  const history = useHistory();

  const token = localStorage.getItem("jwtToken");
  const decodedToken = jwt_decode(token);
  const userInfo = decodedToken;

  const [inpval, setINP] = useState({
    first_name: "",
    last_name: "",
    country: "",
    country_currency: "",
    email: "",
    mobile: "",
    personal_mobile: "",
    user_id: "",
  });

  useEffect(() => {
    // Fetch current user data
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`${apiConfig.baseURL}/api/users/singleUserBalance/${userInfo.user_id}`);
        const userData = response.data;

        // Set initial state with user data
        setINP({
          first_name: userData.first_name,
          last_name: userData.last_name,
          country: userData.country,
          country_currency: userData.country_currency,
          email: userData.email,
          mobile: userData.mobile,
          personal_mobile: userData.personal_mobile,
          user_id: userData.user_id,
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [userInfo.user_id]);

  const setdata = (e) => {
    const { name, value } = e.target;
    setINP((preval) => ({
      ...preval,
      [name]: value,
    }));
  };

  const addinpdata = async (e) => {
    e.preventDefault();

    const {
      first_name,
      last_name,
      country,
      country_currency,
      email,
      mobile,
      personal_mobile,
      user_id,
    } = inpval;

    // Validation
    if ( !mobile ) {
      alert("Please fill in all Wtspp No");
      return;
    }
    
    // if (!first_name || !last_name || !country  || !mobile ||  !personal_mobile || !country_currency) {
    //   alert("Please fill in all required fields");
    //   return;
    // }

    try {
      const res = await axios.post(`${apiConfig.baseURL}/api/users/ProfileManage/${user_id}`, {
        first_name,
        last_name,
        country,
        country_currency,
        email,
        mobile,
        personal_mobile,
        user_id,
      });

    if (res.status === 200) {
        alert("Update Successfully");
        history.push("/agent");
      } else {
        console.log(res.status);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        alert("Validation failed. Please check your input.");
      } else {
        console.error(error);
        alert("Internal Server Error");
      }
    }
  };

  return (
    <>
    <div id="main-wrapper"> 
      <Navbar />
      <Chatbox />
      <HeaderRight />
      <LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Whatspp Live Chat</h4>
              </div>
              <div className="card-body">
                <div className="basic-form">
                  <form>

                    <fieldset>                     
                      <div className="mb-3 row d-none">
                        <label className="col-sm-3 col-form-label">
                          First Name
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            name="first_name"
                            className="form-control"
                            placeholder="First Name"
                            onChange={setdata}
                            value={inpval.first_name}
                            required
                          />
                        </div>
                      </div>

                      <div class="mb-3 row d-none">
                        <label class="col-sm-3 col-form-label">Last Name</label>
                        <div class="col-sm-9">
                          <input
                            type="text"
                            name="last_name"
                            class="form-control"
                            placeholder="Last Name"
                            onChange={setdata}
                            value={inpval.last_name}
                            required
                          />
                        </div>
                      </div>

                      <div class="mb-3 row">
                      <label class="col-sm-3 col-form-label">WhatsApp No ( কান্ট্রি কোড যুক্ত করতে হবে )  </label>
                        <div class="col-sm-9">
                        <input
                          
                          type="text"
                          name="mobile"
                          class="form-control"
                          placeholder="Mobile Number"
                          onChange={setdata}
                          value={inpval.mobile}
                        />
                      </div>
                    </div>

                    <div class="mb-3 row d-none">
                      <label class="col-sm-3 col-form-label">Personal Contact mobile</label>
                      <div class="col-sm-9">
                        <input
                          
                          type="text"
                          name="personal_mobile"
                          class="form-control"
                          placeholder="Contact Number"
                          onChange={setdata}
                          value={inpval.personal_mobile}
                        />
                      </div>
                    </div>

                    <div class="mb-3 row d-none">
                        <label class="col-sm-3 col-form-label">Country</label>
                        <div class="col-sm-9">
                        <select
                            id="country"
                            name="country"
                            className="form-control"
                            onChange={setdata}
                            value={inpval.country}
                            required
                          >
                            <option  value="">Select One </option>
                            <option value="Argentina">Argentina</option>
                            <option value="Armenia">Armenia</option>
                            <option value="Aruba">Aruba</option>
                            <option value="Australia">Australia</option>
                            <option value="Austria">Austria</option>
                            <option value="Azerbaijan">Azerbaijan</option>
                            <option value="Bahamas">Bahamas</option>
                            <option value="Bahrain">Bahrain</option>
                            <option value="Bangladesh">Bangladesh</option>
                          
                          </select>
                        </div>
                      </div>

                      <div class="mb-3 row d-none">
                        <label class="col-sm-3 col-form-label">
                          Country Currency
                        </label>
                        <div class="col-sm-9">
                        <select
                          id="country_currency"
                          name="country_currency"
                          className="form-control"
                          onChange={setdata}
                          value={inpval.country_currency}
                          required
                        >
                            <option value="">
                              Select One
                            </option>
                            <option value="USD" label="US dollar">
                              USD
                            </option>

                            <option value="EUR" label="Euro">
                              EUR
                            </option>
                            <option value="JPY" label="Japanese yen">
                              JPY
                            </option>
                           
                            <option value="BDT" label="Bangladeshi taka">
                              BDT
                            </option>
                          
                          </select>
                        </div>
                      </div>

                    </fieldset>
                    {/* ... (Other hidden fields) */}

                    <div className="mb-3 row">
                      <div className="col-sm-10">
                        <button
                          type="submit"
                          name="send"
                          onClick={addinpdata}
                          className="btn btn-primary"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                     
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
       </div>
    </>
  );
};

export default ProfileManage;
